<template>
    <div
        v-show="condition && show"
        :style="details.style"
        class="top_md"
    >
      <div class="md_body">
        <div class="md_title">
          {{ this.$t(details.title) }}
        </div>
        <div class="md_description">
          {{ this.$t(details.description) }}
        </div>
      </div>
      <div class="top_md_close pointer">
        <img
            src="@/assets/images/svg/ic-close-white.svg"
            alt=""
            @click="closeTopModal()"
        />
      </div>
    </div>
</template>
<script>
export default {
  name: 'topModal',
  props: ['details'],
  data() {
    return {
      show: true
    }
  },
  methods: {
    closeTopModal() {
      this.show = false
    }
  },
  computed: {
    condition() {
      return this.moment().isBetween(this.details.fromStart, this.details.toEnd, undefined, '[]');
    }
  }
}
</script>
<style lang="scss">
.top_md {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: var(--blue70);
  display: flex;
  justify-content: center;
  padding: 20px 0 25px 0;
  z-index: 1;

  .md_body {
    max-width: 60%;
    min-width: 55%;
    margin-left: 52px;

    .md_title {
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      color: var(--white);
      padding: 0 0 12px 0;
    }

    .md_description {
      text-align: center;
      font-size: 14px;
      color: var(--white);
    }
  }

  .top_md_close {
    display: flex;
    padding: 10px;
  }
}
</style>